import {Injectable} from '@angular/core';
import * as moment from 'moment';
import * as _ from 'underscore';

@Injectable()
export class DatesParserService {

    constructor() {
    }

    cleanDates(params: Object, keys: Array<string>, removeOthers?: boolean): Object {
        let copyParams = Object.assign({}, params);

        keys.forEach(function (value) {
            if(copyParams.hasOwnProperty(value)){
                copyParams[value] = (moment.isMoment(copyParams[value])) ? copyParams[value].format('YYYY-MM-DD HH:mm:ss') : copyParams[value];
            }
        });

        if(removeOthers){
            for(let key in copyParams){
                let idx = _.indexOf(keys, key);
                if(idx < 0){
                    delete copyParams[key];
                }
            }
        }

        return copyParams;
    }
}


// WEBPACK FOOTER //
// /var/www/backend/src/app/core/service/dates_parser.service.ts